import { Info, Radar } from '@mui/icons-material';

import Chip from '@/components/ui/Chip/Chip';
import Tooltip from '@/components/ui/Tooltip/Tooltip';
import useFormatMessage from '@/hooks/useFormatMessage';

const InstantQuoteChip = () => {
  const formatMessage = useFormatMessage();

  return (
    <Chip color="secondary" uppercase gap={1}>
      <Radar sx={{ width: 18, height: 18 }} />
      {formatMessage('price_tile_send_automated_offer')}
      <Tooltip
        title={formatMessage('price_tile_send_automated_offer_tooltip')}
        enterTouchDelay={0}>
        <Info sx={{ width: 18, height: 18 }} />
      </Tooltip>
    </Chip>
  );
};

export default InstantQuoteChip;
